module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar additionalClasses = []\nif(config.type) \t\t\t\tadditionalClasses.push(`type-${config.type}`);\nif(model.active) \t\t\t\tadditionalClasses.push('active');\nif(config.additionalClasses) {\nif(typeof config.additionalClasses === 'string'){\nadditionalClasses.push(config.additionalClasses);\n} else if (Array.isArray(config.additionalClasses)){\nadditionalClasses = additionalClasses.concat(config.additionalClasses);\n}\n}\n%><div class=\"<%= additionalClasses.join(' ') %>\">\n<div class=\"container\">\n<div class=\"popover_trigger\"><%- config.prepareEmpty ? model.triggerHTML ? model.triggerHTML : '' : include('./trigger', { resourceData: resourceData, model: model, config: { type: config.type }}); %></div>\n<div class=\"popover_content\"><%- config.prepareEmpty ? '' : include('./content', { resourceData: resourceData, model: model, config: { type: config.type }}); %></div>\n</div>\n</div>"
  , __filename = "..\\frontend-controller\\baseComponents\\popover\\popover.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var additionalClasses = []
if(config.type) 				additionalClasses.push(`type-${config.type}`);
if(model.active) 				additionalClasses.push('active');
if(config.additionalClasses) {
if(typeof config.additionalClasses === 'string'){
additionalClasses.push(config.additionalClasses);
} else if (Array.isArray(config.additionalClasses)){
additionalClasses = additionalClasses.concat(config.additionalClasses);
}
}

    ; __line = 12
    ; __append("<div class=\"")
    ; __append(escapeFn( additionalClasses.join(' ') ))
    ; __append("\">\n<div class=\"container\">\n<div class=\"popover_trigger\">")
    ; __line = 14
    ; __append( config.prepareEmpty ? model.triggerHTML ? model.triggerHTML : '' : include('./trigger', { resourceData: resourceData, model: model, config: { type: config.type }}) )
    ; __append("</div>\n<div class=\"popover_content\">")
    ; __line = 15
    ; __append( config.prepareEmpty ? '' : include('./content', { resourceData: resourceData, model: model, config: { type: config.type }}) )
    ; __append("</div>\n</div>\n</div>")
    ; __line = 17
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\frontend-controller\baseComponents\popover\popover.ejs

}